import { render, staticRenderFns } from "./RevealStepForm.vue?vue&type=template&id=72bb0dbe&scoped=true"
import script from "./RevealStepForm.vue?vue&type=script&lang=js"
export * from "./RevealStepForm.vue?vue&type=script&lang=js"
import style0 from "./RevealStepForm.vue?vue&type=style&index=0&id=72bb0dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb0dbe",
  null
  
)

export default component.exports